module.exports = __webpack_public_path__ + "static/img/keshi4.766aedbc.webp";